import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { FacultyPage } from '@features/groups/components/pages/FacultyPage'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/faculty/')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load your faculty'>
            <Suspense fallback={<LoadingIndicator resource='your faculty' />}>
                <FacultyPage mode='my' navMode='my' />
            </Suspense>
        </QueryErrorBoundary>
    )
}
